import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'companyNameFilterPipe'
})
export class CompanyNameFilterPipe implements PipeTransform {

  transform(value: any): any {
    let output = !_.isUndefined(value) ? value : "";
    if (output.length > 45) {
      return output.substring(0, 45) + "...";
    } else {
      return output;
    }
  }

}
